import $ from 'jquery';

const tourConfig = {
  getOptions: (language) => {
    return {
      nextLabel: language.tour.common.nextLabel,
      prevLabel: language.tour.common.prevLabel,
      skipLabel: language.tour.common.skipLabel,
      doneLabel: language.tour.common.doneLabel,
      tooltipClass: "tourTooltip",
      scrollToElement: false,
      disableInteraction: true
    }
  },
  openTourJsCall: (tourSteps, closeTour, language, scrollSelector) => {
    setTimeout(() => {
      var intro = introJs();
      var tourOptions = tourSteps(language);
      tourOptions.steps = tourOptions.steps.filter(function (obj) { return $(obj.element).length; })
      intro.setOptions(tourOptions);
      intro.onexit(() => {
        if (scrollSelector) {
          $(scrollSelector).off();
        }
        closeTour();
      });
      intro.onafterchange((targetElement) => {
        var target = $(targetElement);

        //fixes de posicion del help number y del tooltip para algunos casos
        $(".introjs-helperNumberLayer").removeClass("fix-help-number");
        $(".introjs-tooltipReferenceLayer").removeClass("fix-bottom-tooltip");
        if (target.hasClass("fix-bad-tour-position")) {
          $(".introjs-helperNumberLayer").addClass("fix-help-number");
          if (target.hasClass("fix-bottom")) {
            $(".introjs-tooltipReferenceLayer").addClass("fix-bottom-tooltip");
          }
        }

        // fix para aumenrar el ancho del helper fix-super-wide
        $(".introjs-tooltipReferenceLayer").removeClass("fix-super-wide");
        if (target.hasClass("fix-super-wide")) {
          $(".introjs-tooltipReferenceLayer").addClass("fix-super-wide");
        }

        //setear div aux que ayuda a customizar area de iluminado
        if (target.hasClass("tour-aux-light-area")) {
          target.parent().addClass("introjs-showElement");
          target.parent().addClass("introjs-relativePosition");
        }

        //fix de movimiento incontrolable de foco del tour
        if (scrollSelector) {
          $(scrollSelector).scrollTop(0);
        }
      });

      //fix de movimiento incontrolable de foco del tour y perdida de posicion de area de iluminado
      if (scrollSelector) {
        $(scrollSelector).scroll(() => {
          $(scrollSelector).scrollTop(0);
          intro.refresh();
        });
      }

      intro.start();
    }, 100);
  }
}

export default tourConfig;



// WEBPACK FOOTER //
// ./source/client/components/common/tour/config.js